import { create } from "zustand";

interface DialogPhoto {
  id: string;
  name: string;
}

/**
 * Try-On Photos Store
 * Silme onayı — fotoğraf verisi TanStack Query cache'inde,
 * isim düzenleme kartın kendi local state'inde yaşar.
 */
interface TryOnPhotosStore {
  deletingPhoto: DialogPhoto | null;
  openDeleteDialog: (photo: DialogPhoto) => void;
  closeDeleteDialog: () => void;
}

export const useTryOnPhotosStore = create<TryOnPhotosStore>((set) => ({
  deletingPhoto: null,
  openDeleteDialog: (photo) => set({ deletingPhoto: photo }),
  closeDeleteDialog: () => set({ deletingPhoto: null }),
}));
